import { authHeader, handleResponse } from "../helper/auth-header";

export default class ShippersPackingService {
  ControllerName = "ShippersPacking";

  async shippersDetails(cartonId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/shippersDetails/${cartonId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
